export default __webpack_public_path__ + "static/media/iron-sights-flat.5fe48c56.svg";